import * as THREE from "three";

export default class RaycastIntersection {
    point: THREE.Vector3;
    normalInWcs: THREE.Vector3 | null = null;
    object: THREE.Object3D | null = null;
    
    constructor(point: THREE.Vector3, normalInWcs: THREE.Vector3 | null, object: THREE.Object3D | null = null) {
        this.point = point.clone();
        this.normalInWcs = normalInWcs ? normalInWcs.clone() : null;
        this.object = object;
    }

    static create(source: THREE.Intersection) {

        let normalInWcs : THREE.Vector3 | null = null;

        if (source && source.normal) {
            const normal = source.normal.clone();
            source.object.updateMatrixWorld(true);
            const normalMatrix = new THREE.Matrix3().getNormalMatrix(source.object.matrixWorld);
            normal.applyMatrix3(normalMatrix).normalize();
            normalInWcs = normal;
        }

        return new RaycastIntersection(source.point, normalInWcs, source.object);
    }

}